"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemTextOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        root: {
            marginTop: spacing(1),
            marginBottom: spacing(1),
        },
        primary: (_b = {
                fontSize: typography.pxToRem(16),
                lineHeight: 1.36,
                "$multiline &": {
                    marginBottom: "0.5em",
                }
            },
            _b[breakpoints.up("xl")] = {
                fontSize: typography.pxToRem(18),
            },
            _b),
        multiline: {
            marginTop: undefined,
            marginBottom: undefined,
        },
    });
};
//# sourceMappingURL=MuiListItemText.js.map